<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
    <v-dialog @click:outside="onClose()" v-model="dialog" id="settings" width="800px"
        :fullscreen="$vuetify.breakpoint.xsOnly">
        <v-card>
            <v-card-title class="py-6">
                <div class="text-h6 text-sm-h4" style="word-break: break-word;">
                    {{ language.t('Settings.settings') }}</div>
                <!-- <v-spacer></v-spacer>
                <v-btn icon color="blue darken-1" @click="$emit('close');">
                    <v-icon>mdi-close</v-icon>
                </v-btn> -->
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col md="4" cols="12">
                            <v-container class="pa-0" style="height: 100%">
                                <v-row no-gutters style="height: 50%">
                                    <v-col>
                                        <div class="text-h6 text-sm-h5" style="word-break: break-word;">
                                            {{ language.t('Settings.languageOptions') }}</div>
                                        <v-radio-group v-model="selectedLanguage" column>
                                            <v-radio v-for="(l, i) in languages" :key="l.dbId" class="pr-3"
                                                :value="l.localeCode" :label="language.t('Settings.'
                                                    + l.name)"></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters style="height: 50%">
                                    <v-col>

                                        <div class="text-h6 text-sm-h5" style="word-break: break-word;">
                                            {{ language.t('Settings.units') }}</div>
                                        <v-radio-group v-model="selectedUnitSystem" column>
                                            <v-radio :key="1" class="pr-3" value="me"
                                                :label="language.t('Settings.metric')"></v-radio>
                                            <v-radio :key="2" class="pr-3" value="im"
                                                :label="language.t('Settings.imperial')"></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                            </v-container>



                            <!-- <v-btn-toggle v-model="selectedLanguage" mandatory group return-object
                                @change="saveSettings">
                                <v-container>
                                    <v-row v-for="(item, index) in languages" :key="item.dbId">
                                        <v-col class="pa-0">
                                            <v-btn class="ma-1" large :value="item.localeCode">{{ language.t('Settings.'
                                                + item.name) }}</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-btn-toggle> -->

                            <!-- 
                            <v-btn-toggle v-model="selectedUnitSystem" mandatory group return-object
                                @change="saveSettings">
                                <v-container>
                                    <v-row>
                                        <v-col class="pa-0">
                                            <v-btn class="ma-1" large value="me">{{ language.t('Settings.metric')
                                                }}</v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="pa-0">
                                            <v-btn class="ma-1" large value="im">{{ language.t('Settings.imperial')
                                                }}</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-btn-toggle> -->

                        </v-col>
                        <v-col md="8" cols="12">
                            <div class="text-h6 text-sm-h5" style="word-break: break-word;">
                                {{ language.t('Settings.projecionOptions') }}</div>
                            {{ language.t('Settings.projectionSelected') }}
                            <v-list style="max-height: 50vh" class="overflow-y-auto">
                                <v-radio-group v-model="defaultProjection" column>
                                    <v-list-item v-for="(projection) in projections" :key="projection.projectionId"
                                        class="d-flex justify-start align-center">
                                        <v-radio class="pr-3" :value="projection.projectionId"
                                            @mouseup="reset(projection.projectionId)"></v-radio>
                                        <v-checkbox dense :label="projection.code + ' - ' + projection.name"
                                            :value="projection.projectionId" v-model="checkedProjections"
                                            :disabled="projection.projectionId == defaultProjection"></v-checkbox>
                                    </v-list-item>
                                </v-radio-group>
                            </v-list>
                        </v-col>
                    </v-row>
                </v-container>

            </v-card-text>
            <v-card-actions class="card-actions">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="onClose" :loading="saving">
                    <v-icon>mdi-close</v-icon>{{ language.t('App.close') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { setCookie, getCookie } from '../models/Cookies';

export default {
    components: {
    },
    props: {
        /* Map.vue reference */
        map: {
            required: true,
        },
    },
    data() {
        return {
            dialog: true,
            saving: false,
            selectedLanguage: this.language.locale,
            selectedUnitSystem: this.$selectedUnitSystem,
            projectionsLoaded: false,
            projectionsInDatabase: [],
            checkedProjections: [],
            defaultProjection: 0,
            languages: [
                { name: "dutch", dbId: 1, localeCode: "nl" },
                { name: "english", dbId: 2, localeCode: "en" },
                { name: "german", dbId: 3, localeCode: "de" },
                { name: "french", dbId: 4, localeCode: "fr" },
            ]
        };
    },
    mounted: function () {
        this.getProjections();
    },
    computed: {
        projections: {
            get() {
                return this.$projections.all;
            }
        },
        customerProjections: {
            get() {
                return this.$projections.customer;
            }
        },
        customerId: {
            get() {
                return this.$auth.customerId;
            }
        }
    },
    watch: {
        defaultProjection(val) {
            if (!this.checkedProjections.some(e => e == val)) {
                this.checkedProjections.push(val);
            }
        },
        selectedLanguage(val) {
            this.saveSettings()
        },
        selectedUnitSystem(val) {
            this.saveSettings()
        }
    },
    methods: {
        reset(val) {
            if (val == this.defaultProjection) {
                setTimeout(() => {
                    this.defaultProjection = 0;
                }, 1)
            }
        },
        getProjections() {
            this.customerProjections.forEach(projection => {
                this.projectionsInDatabase.push(projection.projectionId);
            });
            this.checkedProjections = Array.from(this.projectionsInDatabase);

            this.defaultProjection = this.$projections.defaultProjectionId;
        },
        saveSettings() {
            if (this.selectedLanguage in this.language.messages && this.selectedLanguage != this.language.locale) {
                setCookie('language', this.selectedLanguage, 365);
                this.language.locale = this.selectedLanguage;

                var selectedLangObj = this.languages.find(i => i.localeCode == this.selectedLanguage)
                if (selectedLangObj) this.$axios.post(route('api.user.language', { languageId: selectedLangObj.dbId }));
            }

            if (this.selectedUnitSystem != this.$selectedUnitSystem) {
                setCookie('selectedUnitSystem', this.selectedUnitSystem, 365);
                this.$selectedUnitSystem = this.selectedUnitSystem;
            }
        },
        async onClose() {
            this.saving = true;
            await this.saveProjections();
            this.saving = false;
            this.$emit("close");
        },
        async saveProjections() {
            var promises = [];
            var removedValues = this.projectionsInDatabase.filter(projectionId => !this.checkedProjections.some(selectedProjectionId => selectedProjectionId === projectionId));
            var newValues = this.checkedProjections.filter(selectedProjectionId => !this.projectionsInDatabase.some(projectionId => projectionId === selectedProjectionId));
            var promise = null;

            newValues.forEach((customerProjection) => {
                if (customerProjection != 0) {
                    promise = this.$axios.post(route("api.customer.customerProjections.add", [this.customerId, customerProjection]));
                    promises.push(promise);
                }
            });
            removedValues.forEach((customerProjection) => {
                promise = this.$axios.post(route("api.customer.customerProjections.remove", [this.customerId, customerProjection]));
                promises.push(promise);
            });

            if (this.defaultProjection != this.$projections.defaultProjectionId) {
                promise = this.$axios.post(route("api.customer.customerProjections.default", [this.customerId, this.defaultProjection]));
                promises.push(promise);
            }

            await Promise.all(promises);
            await this.map.setCustomerProjections();
        }
    },
};
</script>
<style scoped>
.btn-toggle {
    flex-direction: column;
}
</style>